module.exports = __webpack_public_path__ + "static/media/exit.2df21551.png";